import Moment from 'moment';
import * as messagingTypes from './messagingTypes';
import { MESSAGEBOX_TYPES, MESSAGEDETAIL_TYPES, TIMER_START, TIMER_STOP, TIMER_TYPES, MSG_MONITOR_INTERVAL } from 'src/constants/constants';
import {
  fetchMessages,
  fetchCounts,
  getAccounts,
  delMessages,
  postMessage,
  fetchMessageDetails,
  upLoadAttachmentService,
  fetchCasesMessages,
  saveCaseManagerIdService,
  downloadAttachmentService,
} from 'src/services/messages.service';
import { getLastMailDate, getFirstMailDate, getFiltersByMailBox, getFirstMessage, getLoginInfo } from './messagingReselect';
import { getCaseManagerId } from 'src/ui/features/Cases/state/casesReselect';
import { push } from 'connected-react-router';
import { PRIORITY, INVALID_TOKEN, MESSAGING_COMPOSE_URL, LOGIN_URL } from '../../../../constants/constants';
import * as loginActions from '../../Login/state/loginActions';
import { saveAPIFile } from 'src/helpers';
import { showNotification } from 'src/utils/utilsActions';

export const getAllMailAndCounts = opts => {
  return (dispatch, getState, setLock, onStart, onComplete) => {
    onStart();
    /*
     * We can not rely on counts so the way to examine changes is to ping each endpoint with a fromDate of the last mail and then
     * Fire off requests to each mailbox in parallel then retrieve the counts after promises are resolved
     */
    const { userInfo } = getLoginInfo(getState());
    const lastInboxDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.INBOX);
    const lastSentDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.SENT);
    const lastDraftDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.DRAFT);

    const caseManagerId = getCaseManagerId(getState());

    const inboxFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.INBOX);
    const sentFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.SENT);
    const draftFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.DRAFT);
    const selectedEngagement = getState().dashboard.selectedEngagement;

    const mailBoxes = [
      {
        boxType: MESSAGEBOX_TYPES.INBOX,
        action: fetchMessages(
          MESSAGEBOX_TYPES.INBOX,
          {
            ...(caseManagerId && { caseManagerId }),
            ...inboxFilters,
            dateFrom: lastInboxDate, //if not null, return date, otherwise '',
            engagementId: selectedEngagement && selectedEngagement.engagementId,
          },
          userInfo.personId,
        ),
      },
      {
        boxType: MESSAGEBOX_TYPES.SENT,
        action: fetchMessages(
          MESSAGEBOX_TYPES.SENT,
          {
            ...(caseManagerId && { caseManagerId }),
            ...sentFilters,
            dateFrom: lastSentDate,
            engagementId: selectedEngagement && selectedEngagement.engagementId,
          },
          userInfo.personId,
        ),
      },
      {
        boxType: MESSAGEBOX_TYPES.DRAFT,
        action: fetchMessages(
          MESSAGEBOX_TYPES.DRAFT,
          {
            ...(caseManagerId && { caseManagerId }),
            ...draftFilters,
            dateFrom: lastDraftDate,
            engagementId: selectedEngagement && selectedEngagement.engagementId,
          },
          userInfo.personId,
        ),
      },
    ];

    Promise.all(mailBoxes.map(box => box.action)).then(results => {
      try {
        if (results[0].error) {
          const { error } = results[0];
          if (error.code && error.code === '403') {
            dispatch({ type: messagingTypes.CHECK_STATUS });
          }
          throw Error(error.message);
        }
        results.forEach((item, index) => {
          if (item) {
            dispatch(getMessagesSuccess(mailBoxes[index].boxType, item, true));
          }
        });

        dispatch(getCounts());

        setLock(false);
        onComplete();
      } catch (error) {
        if (error.message.indexOf(INVALID_TOKEN) > 0) {
          /* I believe this code can probably be removed, but needs to be done after december demo. This
           * is now handled in the axios helper */

          dispatch(loginActions.loginFailure({ error: { message: 'The credentials has expired, please login Again' } }));
          dispatch(push(LOGIN_URL));
        }
        setLock(false);
      }
    });

    setLock(true);
  };
};

export const runMessagingMonitor = opts => {
  return {
    type: TIMER_START,
    payload: {
      name: TIMER_TYPES.MESSAGING,
      action: getAllMailAndCounts(opts),
      timeout: MSG_MONITOR_INTERVAL,
      ...opts,
    },
  };
};

export const stopMessagingMonitor = () => ({
  type: TIMER_STOP,
  payload: {
    name: TIMER_TYPES.MESSAGING,
  },
});

export const selectMessage = id => {
  return async dispatch => {
    dispatch({ type: messagingTypes.SELECT_MESSAGE, id });
    dispatch(getMessageDetails(id));
  };
};

export const selectMenu = data => ({
  type: messagingTypes.SELECT_MENU,
  data,
});

export const selectDetailView = data => ({
  type: messagingTypes.SELECT_DETAIL_VIEW,
  data,
});

export const getMessagesSuccess = (menu, data, insertFront = false) => {
  if (menu === 'sent') {
    data.messages = data.messages.map(message => {
      message.read = true;
      return message;
    });
  }

  return {
    type: messagingTypes.GET_MESSAGES_SUCCESS,
    menu,
    data,
    insertFront,
  };
};

export const getMessageDetailsSuccess = data => ({
  type: messagingTypes.GET_MESSAGE_DETAILS_SUCCESS,
  data,
});

export const getCountsSuccess = data => ({
  type: messagingTypes.GET_COUNTS_SUCCESS,
  data,
});

export const getPaginatedMessages = () => {
  return async (dispatch, getState) => {
    const currentState = getState();

    const { userInfo } = getLoginInfo(getState());
    const mailboxType = currentState.messaging.selectedMenu;
    const caseManagerId = getCaseManagerId(getState());
    const selectedEngagement = getState().dashboard.selectedEngagement;

    const lastDate = getLastMailDate(getState(), mailboxType);
    const boxFilters = getFiltersByMailBox(getState(), mailboxType);

    fetchMessages(
      mailboxType,
      {
        ...(caseManagerId && { caseManagerId }),
        ...boxFilters,
        dateTo: lastDate, //AG need to verify
        fromDate: undefined,
        engagementId: selectedEngagement && selectedEngagement.engagementId,
      },
      userInfo.personId,
    ).then(res => {
      dispatch(getMessagesSuccess(mailboxType, res));
    });
  };
};

export const getMessageDetails = messageId => {
  return async (dispatch, getState) => {
    dispatch(getMessageDetailsSuccess((await fetchMessageDetails(messageId)).message));
  };
};

export const getCounts = () => {
  return async (dispatch, getState) => {
    dispatch(getCountsSuccess(await fetchCounts()));
  };
};

export const selectShownId = () => {
  return async (dispatch, getState) => {
    const id = getState().messaging.messageShown.id;
    dispatch({ type: messagingTypes.SELECT_MESSAGE, id });
  };
};

export const selectMenuAndReset = (menu, resetMessage = true) => {
  return async (dispatch, getState) => {
    if (resetMessage) {
      dispatch(resetMessageShown());
    }
  };
};

export const searchMessages = menu => {
  return async (dispatch, getState) => {
    dispatch(resetMessageShown());

    dispatch(
      runMessagingMonitor({
        onComplete: async () => {
          let message, messageId;
          message = getFirstMessage(getState(), menu);
          messageId = message ? message.id : null;

          if (!messageId) return;

          message = (await fetchMessageDetails(messageId)).message;
          dispatch({ type: messagingTypes.SELECT_MESSAGE, id: messageId });
          dispatch(getMessageDetailsSuccess(message));
          dispatch(selectShownId());
          dispatch(selectMenu(menu));
        },
      }),
    );
  };
};

export const deleteMessages = (menu, data, caseManagerId, callback) => {
  return async dispatch => {
    const { success } = await delMessages(menu, data, caseManagerId);

    if (success) {
      dispatch(selectMenuAndReset(menu));
      if (typeof callback === 'function') {
        callback();
      }
    }
  };
};

export const showNotificationSuccess = data => ({
  type: messagingTypes.SHOW_NOTIFICATION_SUCCESS,
  data,
});

export const sendMessagePending = () => ({
  type: messagingTypes.SENDMESSAGE_PENDING,
});

export const hideNotificationSuccess = () => ({
  type: messagingTypes.HIDE_NOTIFICATION_SUCCESS,
  data: '',
});

export const saveCaseManagerId = payload => {
  return async (dispatch, getState) => {
    const { success } = await saveCaseManagerIdService(payload);
    if (success) {
      dispatch(selectMessage(payload.messageId));
    }
  };
};

export const sendMessage = (message, notifText, simpleSave, callback = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(sendMessagePending());

    const { userInfo } = getLoginInfo(getState());
    const response = await postMessage({
      from: userInfo.email,
      ...message,
      priority: message.priority ? PRIORITY.HIGH.toLowerCase() : PRIORITY.NORMAL.toLowerCase(),
      date: Moment()
        .utc()
        .format(),
    });

    if (response && response.success) {
      dispatch(getCounts());
      dispatch(showNotificationSuccess(notifText));
      callback();

      /* For simple save operation escape all of the other ceremony */
      if (typeof simpleSave === 'boolean' && simpleSave) return;

      const draftmessages = getState().messaging.draft.messages;
      // Check if 1st message in draft list is sent, If "Yes" and if there are more than 1 records in the list,
      // set the focus on next message. Else call the readonly view as there are no more draft messages left.
      if (getState().messaging.selectedMenu === MESSAGEBOX_TYPES.DRAFT) {
        dispatch(selectDetailView(MESSAGEDETAIL_TYPES.DRAFT));
        if (!message.isdraft && draftmessages.length > 0)
          if (draftmessages[0].id === message.messageId) {
            draftmessages.length === 1
              ? dispatch(selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE))
              : dispatch(selectMessage(draftmessages[1].id));
          } else dispatch(selectMessage(draftmessages[0].id));
      } else dispatch(selectDetailView(MESSAGEDETAIL_TYPES.VIEWMESSAGE));

      dispatch(runMessagingMonitor());
      dispatch(resetAttachments());
      dispatch(selectMenuAndReset(getState().messaging.selectedMenu));
    }
  };
};

export const applyFilters = payload => ({
  type: messagingTypes.APPLY_FILTERS_PENDING,
  payload,
});
export const applyFiltersSuccess = () => ({
  type: messagingTypes.APPLY_FILTERS_SUCCESS,
});
export const applyFiltersFailure = error => ({
  type: messagingTypes.APPLY_FILTERS_FAILURE,
  error,
});

export const clearFilters = () => ({
  type: messagingTypes.CLEAR_FILTERS_PENDING,
});

export const clearFiltersSuccess = () => ({
  type: messagingTypes.CLEAR_FILTERS_SUCCESS,
});

//showModal
export const toggleModal = (status, anchorEl) => ({
  type: messagingTypes.SHOW_FILTER_MODAL,
  status,
  anchorEl,
});

//handleAnchor
export const changeSortOrder = sortDirection => ({
  type: messagingTypes.CHANGE_SORT_ORDER,
  sortDirection,
});

export const switchView = view => ({
  type: messagingTypes.SWITCH_VIEW,
  view,
});

export const loadEngagementsPending = () => ({
  type: messagingTypes.ENGAGEMENT_LOAD_PENDING,
});

export const loadEngagementsSuccess = engagements => ({
  type: messagingTypes.ENGAGEMENT_LOAD_SUCCESS,
  engagements,
});

export const toggleComposeDrawer = () => {
  return (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: messagingTypes.TOGGLE_COMPOSE_DRAWER,
      payload: {
        open: !state.messaging.composeDrawerState.open,
      },
    });
  };
};

export const checkStatusPending = () => ({
  type: messagingTypes.CHECK_STATUS,
});

export const setAttachments = (composeId, attachmentId) => ({
  type: messagingTypes.SET_ATTACHMENTS,
  composeId,
  attachmentId,
});

export const setComposeId = data => ({
  type: messagingTypes.SET_COMPOSE_ID,
  data,
});

export const upLoadAttachment = (data, callback) => {
  return async dispatch => {
    const response = await upLoadAttachmentService(data, {
      timeout: 180000,
      onUploadProgress: progressEvent => {
        if (typeof callback === 'function') {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          callback(percentCompleted);
        }
      },
    });

    if (response && response.success) {
      dispatch(setAttachments(response.messageId, response.attachmentId));
    }
  };
};

export const downloadAttachment = payload => {
  return async dispatch => {
    const response = await downloadAttachmentService(payload);
    if (response.success) {
      saveAPIFile(response.attachmentData, response.fileName);
    }
  };
};

export const resetAttachments = () => ({
  type: messagingTypes.RESET_ATTACHMENTS,
});

export const deleteAttachment = index => ({
  type: messagingTypes.DELETE_ATTACHMENT,
  index,
});

export const resetComposeId = () => ({
  type: messagingTypes.RESET_COMPOSE_ID,
});

export const resetSearchText = () => ({
  type: messagingTypes.RESET_SEARCH_TEXT,
});

export const setSearchText = data => ({
  type: messagingTypes.SET_SEARCH_TEXT,
  data,
});

export const resetMessageShown = () => ({
  type: messagingTypes.RESET_MESSAGE_SHOWN,
});

// export const getCasesMessagesPending = () => {
//   return {
//     type: messagingTypes.GET_CASES_MESSAGES_PENDING,
//   };
// };

// export const getCasesMessagesFailure = () => {
//   return {
//     type: messagingTypes.GET_CASES_MESSAGES_FAILURE,
//   };
// };

// export const getCasesMessagesSuccess = payload => {
//   return dispatch => {
//     dispatch({
//       type: messagingTypes.GET_CASES_MESSAGES_SUCCESS,
//       payload,
//     });
//   };
// };

export const getCasesMessages = () => {
  return async (dispatch, getState, setLock, onStart, onComplete) => {
    onStart();

    const caseManagerId = getCaseManagerId(getState());
    const inboxFilters = getFiltersByMailBox(getState(), MESSAGEBOX_TYPES.INBOX);
    const lastInboxDate = getFirstMailDate(getState(), MESSAGEBOX_TYPES.INBOX);

    const params = {
      fromDate: lastInboxDate,
      caseManagerId,
      ...inboxFilters,
    };

    // dispatch(getCasesMessagesSuccess(await fetchCasesMessages(params)));
  };
};

export const resumeDraftMode = (emailAddress, caseId) => {
  return async (dispatch, getState) => {
    const accountInfo = await getAccounts(emailAddress.toLowerCase(), 1);

    if (accountInfo.success) {
      dispatch({
        type: messagingTypes.RESUME_DRAFT_MESSAGE,
        accountInfo: accountInfo.emails,
        caseId,
      });
      dispatch(push(MESSAGING_COMPOSE_URL));
    } else if (accountInfo.error && accountInfo.error.message) {
      dispatch(showNotification(accountInfo.error.message, { variant: 'error' }));
    }
  };
};

export const clearResumeDraft = () => ({
  type: messagingTypes.CLEAR_RESUME_DRAFT,
});



// WEBPACK FOOTER //
// ./src/ui/features/Messaging/state/messagingActions.js